import React from "react";
import { reportsData } from "./Components/ReportsData";

const Reports = () => {
    return (
        <div>
            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
                <div className="row g-3">
                    <div className="col-sm-12">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <h3 className="fw-bold mb-0">Reports</h3>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="row g-4 list-unstyled li_animate row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1 row-deck mb-lg-5 mt-2">
                            {reportsData.map((category) => (
                                <div className="col" key={category.id}>
                                    <div className="card reports-cards">
                                        <div className="reports-cards-head-border">
                                            <h2 className="reports-cards-head m-0">{category.report_title}</h2>
                                        </div>
                                        <ul className="p-2">
                                            {category.report_lists.map((report) => (
                                                <li key={report.id}>📋{report.name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Reports;